// src/components/About.js
import React from 'react';

function About() {
  return (
    <section className="about-me" id="about">
      <h2>About Me</h2>
      <div className="about-content">
        <img 
          src={process.env.PUBLIC_URL + '/assets/images/About.jpg'} 
          alt="About Me" 
          className="about-image" 
        />
        <div className="about-description">
          <p>
            Hi, I'm Steff, <br />
            I'm a fine line tattoo artist with a background in art and design. From early
            training in art school to studying interior design, each step has deepened
            my appreciation for the beauty in detail and expression. 
            Through tattooing, I've found a space where intention and spontaneity come together to
            create something unique and lasting. My approach is collaborative and
            personal—especially with freehand work. Each piece evolves naturally,
            shaped by the moment and the shared vision with the person I'm working
            with. Through delicate, intentional lines, I hope to create tattoos that feel
            like an extension of one's self—a subtle, enduring story that resonates
            beyond the skin.
          </p>
        </div>
      </div>
    </section>
  );
}

export default About;